import { loadPairTradeSessionEngine } from '../wallet/PairTradeSessionHost'
import { createPreloadedModule } from './preloadedModule'

// The page arrives with the app-level trade executor in hand: its trading
// surfaces wait for the executor (PairTradeSessionHost), and loading both at
// once keeps a cold token page to one wait instead of two.
const pairPageModule = createPreloadedModule(() =>
  Promise.all([import('../pages/PairPage'), loadPairTradeSessionEngine()]).then(
    ([module]) => module.PairPage
  )
)

export const loadPairPage = () => pairPageModule.load()
export const peekPairPage = () => pairPageModule.peek()
